import { Frame } from '@shared/components/Frame';

export const MinimalLayout = () => {
  return <Frame title="Simpallo" minimum={true} />;
};
